import React from "react";

export default function EnrollmentTerms({ text }) {
  return (
    <div className="signature-terms-body" lang="pt-BR">
      {String(text || "")
        .split(/\n\s*\n/)
        .map((block, index) => {
          const [heading, ...lines] = block.split("\n");
          return /^\d+\./.test(heading) ? (
            <section key={index}>
              <h4>{heading}</h4>
              <p>{lines.join("\n")}</p>
            </section>
          ) : (
            <p key={index}>{block}</p>
          );
        })}
    </div>
  );
}
